<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button fill="solid" (click)="cancel()">
        <ion-icon slot="start" name="close-circle-outline"></ion-icon>
        {{ 'General.Cancel' | translate }}
      </ion-button>
    </ion-buttons>
    <ion-title class="modal-title">{{ title | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-card style="padding: 15px;">
    <h2>{{ 'CreditCard.CreditCard' | translate }}</h2>
    <shared-credit-card-form (onSubmit)="onCreditCardChange($event)"></shared-credit-card-form>
    <h2>{{ 'CreditCard.BillingAddress' | translate }}</h2>
    <shared-address [skipProvinceValidation]="true" [placeHolder]="emptyAddressPlaceHolder" (onChange)="onBillingAddressChanged($event)"></shared-address>
    <br>
    <ion-button [disabled]="!creditCard || !billingAddress" (click)="addCardClicked()">{{ 'CreditCard.AddCard' | translate }}</ion-button>
  </ion-card>
</ion-content>